import { Component } from "@angular/core";

import {
  TEAM_STATUS_BADGE_CLASS,
  TEAM_STATUS_DESCRIPTION_KEY,
  TEAM_STATUS_LABEL_KEY,
  TeamStatusKey,
} from "@bitwarden/web-vault/app/gloss/manage/manage-organizations/team-status";

interface HowItWorksStep {
  titleKey: string;
  descriptionKey: string;
}

@Component({
  selector: "app-teams-info-panel",
  templateUrl: "./teams-info-panel.component.html",
})
export class TeamsInfoPanelComponent {
  readonly steps: HowItWorksStep[] = [
    { titleKey: "teamsStep1Title", descriptionKey: "teamsStep1Desc" },
    { titleKey: "teamsStep2Title", descriptionKey: "teamsStep2Desc" },
    { titleKey: "teamsStep3Title", descriptionKey: "teamsStep3Desc" },
  ];

  readonly statusKeys: TeamStatusKey[] = ["invited", "awaiting", "member", "owner"];
  readonly badgeClass = TEAM_STATUS_BADGE_CLASS;
  readonly badgeLabelKey = TEAM_STATUS_LABEL_KEY;
  readonly badgeDescriptionKey = TEAM_STATUS_DESCRIPTION_KEY;
}
